module.exports = __webpack_public_path__ + "img/enercred-logo-quadrado.b8fbd5e6.png";